import React from "react";
import { Box, Typography, Container, Grid2, Card, CardContent, CardMedia } from "@mui/material";
import { Helmet } from "react-helmet"; // Importing react-helmet
import { useTheme } from "@mui/material/styles";
import Women from "../assets/women_fellowship.jpg";
import Community from "../assets/community outreach.jpg";
import Youth from "../assets/youthmeeting.jpg";
import BibleStudy from "../assets/biblestudy.png";

const MinistriesPrograms = () => {
  const theme = useTheme();

  const ministries = [
    {
      title: "Youth Ministry",
      description:
        "Empowering the next generation through faith, mentorship, and engaging activities that help build a strong spiritual foundation.",
      image: Youth,
    },
    {
      title: "Women’s Fellowship",
      description:
        "A community for women to grow in faith, share life experiences, and encourage one another through prayer and support.",
      image: Women,
    },
    {
      title: "Community Outreach",
      description:
        "Extending Christ’s love through food drives, charitable events, and initiatives that uplift the underprivileged.",
      image: Community,
    },
    {
      title: "Bible Study Groups",
      description:
        "Join small groups dedicated to studying and understanding God’s Word, fostering spiritual growth and deeper relationships.",
      image: BibleStudy,
    },
  ];

  return (
    <Box
      sx={{
        py: 6,
        backgroundColor: "background.default",
        animation: `${theme.keyframes.fadeIn} 1.5s`,
      }}
    >
      {/* SEO Metadata */}
      <Helmet>
        <title>Ministries Programs | Praise Revival Church Dharmapuri</title>
      </Helmet>

      <Container>
        {/* Page Title */}
        <Typography
          variant="h2"
          gutterBottom
          align="center"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            animation: `${theme.keyframes.fadeInUp} 1.5s`,
          }}
        >
          Ministries & Programs
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 4,
            fontSize: "1.2rem",
            color: "text.secondary",
            animation: `${theme.keyframes.fadeInUp} 2s`,
          }}
        >
          Explore the various ministries and programs at Praise Revival Church designed to nurture faith and foster community.
        </Typography>

        {/* Ministries Grid */}
        <Grid2 container spacing={4}>
          {ministries.map((ministry, index) => (
            <Grid2
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{
                animation: `${theme.keyframes.zoomIn} 2s`,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: "350px",
                  boxShadow: theme.shadows[3],
                  borderRadius: 2,
                  overflow: "hidden",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: theme.shadows[5],
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={ministry.image}
                  alt={`${ministry.title} Image`}
                />
                <CardContent sx={{ backgroundColor: "background.paper", textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "primary.main" }}
                  >
                    {ministry.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.primary" }}>
                    {ministry.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Container>
    </Box>
  );
};

export default MinistriesPrograms;
